const tryExtractMessageFromJsonString = (value) => {
    const text = typeof value === 'string' ? value.trim() : '';

    if (!text || (!text.startsWith('{') && !text.startsWith('['))) {
        return '';
    }

    try {
        const parsed = JSON.parse(text);

        if (parsed && typeof parsed === 'object') {
            return (
                String(parsed.message || parsed.error || parsed.detail || '')
                    .trim()
            );
        }
    } catch (_error) {
    }

    return '';
};

const getMessageFromResponseData = (data) => {
    if (!data) {
        return '';
    }

    if (typeof data === 'string') {
        return tryExtractMessageFromJsonString(data) || data.trim();
    }

    if (typeof data === 'object') {
        const directMessage = String(
            data.message || data.error || data.detail || ''
        ).trim();

        if (directMessage) {
            return tryExtractMessageFromJsonString(directMessage) || directMessage;
        }
    }

    return '';
};

export const getErrorMessage = (err) => {
    if (err.response) {
        return getMessageFromResponseData(err.response.data) || `Server error: ${err.response.status}`;
    } else if (err.request) {
        return 'Could not connect to the server. Please check your network connection.';
    } else {
        return (
            tryExtractMessageFromJsonString(err.message) ||
            err.message ||
            'An unknown error occurred.'
        );
    }
};
